module.exports = __webpack_public_path__ + "img/order.9fe30446.jpg";